import { render, staticRenderFns } from "./BaseMyTrumpet.vue?vue&type=template&id=6c37b24e&scoped=true&"
import script from "./BaseMyTrumpet.vue?vue&type=script&lang=js&"
export * from "./BaseMyTrumpet.vue?vue&type=script&lang=js&"
import style0 from "./BaseMyTrumpet.vue?vue&type=style&index=0&id=6c37b24e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c37b24e",
  null
  
)

export default component.exports